import {Component, ElementRef, Input, OnDestroy, Optional} from '@angular/core';
import {NgForm} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ValidatorResult} from '../../validators/validator-result';
import {AppConstants} from '../../utils/app-constants';
import {Subscription} from 'rxjs';
import {ViewportScroller} from '@angular/common';
import {Router} from '@angular/router';

@Component({
  selector: 'app-form-error-list',
  templateUrl: './form-error-list.component.html',
  styles: []
})
export class FormErrorListComponent implements OnDestroy {

  @Input() formName: string;
  @Input() errorMessage: FormErrorMessage;
  @Input() errorListTitle: string;

  errors: { controlKey: string, controlName: string, error: string | ValidatorResult }[] = [];
  formSubscription: Subscription;
  formSubmitSubscription: Subscription;
  routerLink: string;

  constructor(private router: Router,
              private translateService: TranslateService,
              private viewportScroller: ViewportScroller,
              private elRef: ElementRef,
              @Optional() private form: NgForm) {
    this.routerLink = router.url.split('#')[0];
    if (form) {
      this.formSubmitSubscription = form.ngSubmit.pipe().subscribe(() => {
        this.detectErrors();
        this.formSubscription = this.form.valueChanges.subscribe(() => this.detectErrors());
        if (this.errors.length) {
          this.elRef?.nativeElement.scrollIntoView({behavior: 'smooth'});
        }
      });
    }
  }

  ngOnDestroy(): void {
    this.formSubscription?.unsubscribe();
    this.formSubmitSubscription?.unsubscribe();
  }

  detectErrors() {
    if (!this.form.submitted) {
      this.errors = [];
      return;
    }

    const controlKeys = Object.keys(this.form.controls);
    this.errors = controlKeys.map(controlKey => {
      if (!this.form.controls[controlKey]?.errors) {
        return null;
      }

      const errorLabelKey = Object.keys(this.form.controls[controlKey].errors)[0];
      const errorLabelValue = this.form.controls[controlKey].errors[errorLabelKey];
      let error;
      if (errorLabelValue && errorLabelValue instanceof ValidatorResult) {
        error = errorLabelValue.getValidatorResultLabel(this.translateService);
      } else {
        error = this.translateService.instant(AppConstants.VALIDATORS_PREFIX + errorLabelKey);
      }

      let controlName = controlKey;
      if (this.translateService.instant(this.formName + '.' + controlName) !== this.formName + '.' + controlName) {
        controlName = this.translateService.instant(this.formName + '.' + controlName);
      }

      return {controlKey, controlName, error};
    }).filter(error => error);
  }

}

export class FormErrorMessage {
  message: string;
  additionalInfo: string;
}
